
import { Button, type ButtonProps } from "@/components/ui/button"
import { MoonIcon, SunIcon } from "lucide-react"
import { useCustomTheme } from "@/contexts/theme-context"
import { useEffect, useState } from "react"

interface ThemeToggleProps {
  variant?: ButtonProps["variant"]
  size?: ButtonProps["size"]
  className?: string
}

export function ThemeToggle({
  variant = "outline",
  size = "sm",
  className = "flex-1",
}: ThemeToggleProps) {
  const { isDarkMode, toggleDarkMode } = useCustomTheme()
  const [mounted, setMounted] = useState(false)

  // Prevent hydration mismatch
  useEffect(() => {
    setMounted(true)
  }, [])

  if (!mounted) {
    return null
  }

  return (
    <Button
      variant={variant}
      size={size}
      className={className}
      onClick={toggleDarkMode}
      aria-label="Toggle dark mode"
    >
      {isDarkMode ? <MoonIcon className="h-5 w-5" /> : <SunIcon className="h-5 w-5" />}
      <span className="sr-only">Toggle dark mode</span>
    </Button>
  )
}
